import React, { useEffect } from "react";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import './Zoom.scss';

const ZoomMeeting = () => {
  const username = localStorage.getItem("username");
  const meetingid = localStorage.getItem("meetingid");
  const password = localStorage.getItem("password");

  useEffect(() => {
    // Add 'active' class to body when component mounts
    document.body.classList.add('active');
    
    const client = ZoomMtgEmbedded.createClient({ mode: "embedded" });
    const meetingContainer = document.getElementById("zoomMeetingContainer");

    // ✅ Validate meeting info before proceeding
    if (!username || !meetingid || !password) {
      console.error("❌ Missing Zoom meeting info in localStorage.");
      return;
    }

    const meetingNumber = Number(meetingid);
    if (!meetingNumber || isNaN(meetingNumber)) {
      console.error("❌ Invalid meeting number:", meetingid);
      return;
    }

    const meetingConfig = {
      meetingNumber,
      userName: username,
      userEmail: "user@example.com",
      passWord: password,
      sdkKey: "DKcyyNBISCx7PIzTouJMQ", // ⚠️ Replace with your actual SDK Key
    };

    const initMeeting = async () => {
      try {
        // ✅ Initialize Zoom client
        await client.init({
          zoomAppRoot: meetingContainer,
          language: "en-US",
          customize: {
            video: {
              isResizable: true,
              viewSizes: {
                default: {
                  width: 100,
                  height: 100,
                },
              },
            },
          },
        });

        // ✅ Fetch meeting signature from backend
        const signatureResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/generate-zoom-signature?meetingNumber=${meetingConfig.meetingNumber}&role=0`
        );

        if (!signatureResponse.ok) {
          throw new Error("Failed to fetch Zoom signature.");
        }

        const { signature } = await signatureResponse.json();

        if (!signature) {
          throw new Error("No signature received from backend.");
        }

        // ✅ Join Zoom meeting
        await client.join({
          signature,
          sdkKey: "4mZ6O3SuRiqyjk6hBocKPA",
          meetingNumber: meetingNumber,
          password: password,
          userName: username,
          userEmail: "user@example.com",
        });

        console.log("✅ Successfully joined the Zoom meeting.");
      } catch (error) {
        console.error("❌ Zoom init/join error:", error);
      }
    };

    initMeeting();

     return () =>{
     document.body.classList.remove('active');
  };
  }, [username, password, meetingid]);

  return (
    <div className="livemeeting">
      <div
        id="zoomMeetingContainer"
        className="width_zoom"
      ></div>
    </div>
  );
};

export default ZoomMeeting;